// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.ViewHistory-module_root___qPmtY {
  display: flex;
  gap: 20px;
  padding: 16px 20px 0;
  min-height: 480px;
}
.theme--light .ViewHistory-module_root___qPmtY {
  color: #212121;
}
.theme--dark .ViewHistory-module_root___qPmtY {
  color: #f0f0f0;
}

.ViewHistory-module_left___hAyAF {
  flex: 0 0 230px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ViewHistory-module_detailBlock___wMCud {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ViewHistory-module_detailLabel___N8d5Y {
  font-size: 1.2rem;
}
.theme--light .ViewHistory-module_detailLabel___N8d5Y {
  color: #888888;
}
.theme--dark .ViewHistory-module_detailLabel___N8d5Y {
  color: #a3a3a3;
}

.ViewHistory-module_detailValue____Dgs9 {
  font-size: 1.4rem;
  font-weight: 600;
}
.theme--light .ViewHistory-module_detailValue____Dgs9 {
  color: #212121;
}
.theme--dark .ViewHistory-module_detailValue____Dgs9 {
  color: #f0f0f0;
}

.ViewHistory-module_right___iBlPh {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.ViewHistory-module_toolbar___wsRNi {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
}

.ViewHistory-module_searchWrapper___PWcE5 {
  flex: 1;
  max-width: 320px;
}

.ViewHistory-module_searchInputContainer___GEIwv {
  min-height: 38px;
}

.ViewHistory-module_filterWrapper___iFEhz {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ViewHistory-module_filterLabel____ZxwT {
  font-size: 1.3rem;
  white-space: nowrap;
}
.theme--light .ViewHistory-module_filterLabel____ZxwT {
  color: #888888;
}
.theme--dark .ViewHistory-module_filterLabel____ZxwT {
  color: #a3a3a3;
}

.ViewHistory-module_filterSelect___rJww_ {
  display: inline-block;
  min-width: 120px;
}

.ViewHistory-module_tableWrap___ePwVB {
  flex: 1;
  min-height: 320px;
  max-height: 480px;
  overflow: auto;
  border-radius: 6px;
}
.theme--light .ViewHistory-module_tableWrap___ePwVB {
  border: 1px solid #dddddd;
}
.theme--dark .ViewHistory-module_tableWrap___ePwVB {
  border: 1px solid #2f2f2f;
}

.ViewHistory-module_stateContainer___TClhz {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 320px;
  font-size: 1.4rem;
}
.theme--light .ViewHistory-module_stateContainer___TClhz {
  color: #888888;
}
.theme--dark .ViewHistory-module_stateContainer___TClhz {
  color: #a3a3a3;
}

.ViewHistory-module_footer___LBV67 {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 2.4rem;
  margin-top: 16px;
}
.theme--light .ViewHistory-module_footer___LBV67 {
  border-top: 1px solid #dddddd;
}
.theme--dark .ViewHistory-module_footer___LBV67 {
  border-top: 1px solid #2f2f2f;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/viewHistory/ViewHistory.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,aAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;AAmBD;AD+EE;EC/FA,cAAA;AAmBF;AD4EE;EC/FA,cAAA;AAsBF;;AAlBA;EACC,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAqBD;;AAlBA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAqBD;;AAlBA;EACC,iBAAA;AAqBD;ADwDE;EC3EA,cAAA;AAsBF;ADqDE;EC3EA,cAAA;AAyBF;;AArBA;EACC,iBAAA;EACA,gBAAA;AAwBD;AD6CE;ECnEA,cAAA;AAyBF;AD0CE;ECnEA,cAAA;AA4BF;;AAxBA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AA2BD;;AAxBA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;AA2BD;;AAxBA;EACC,OAAA;EACA,gBAAA;AA2BD;;AAxBA;EACC,gBAAA;AA2BD;;AAxBA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AA2BD;;AAxBA;EACC,iBAAA;EACA,mBAAA;AA2BD;ADIE;EC7BA,cAAA;AA4BF;ADCE;EC7BA,cAAA;AA+BF;;AA3BA;EACC,qBAAA;EACA,gBAAA;AA8BD;;AA3BA;EACC,OAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AA8BD;ADfE;ECZA,yBAAA;AA8BF;ADlBE;ECZA,yBAAA;AAiCF;;AA7BA;EACC,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AAgCD;AD/BE;ECCA,cAAA;AAiCF;ADlCE;ECCA,cAAA;AAoCF;;AA1BA;EACC,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AA6BD;AD7CE;ECmBA,6BAAA;AA6BF;ADhDE;ECmBA,6BAAA;AAgCF","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.root {\n  display: flex;\n  gap: 20px;\n  padding: 16px 20px 0;\n  min-height: 480px;\n}\n:global(.theme--light) .root {\n  color: #212121;\n}\n:global(.theme--dark) .root {\n  color: #f0f0f0;\n}\n\n.left {\n  flex: 0 0 230px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.detailBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.detailLabel {\n  font-size: 1.2rem;\n}\n:global(.theme--light) .detailLabel {\n  color: #888888;\n}\n:global(.theme--dark) .detailLabel {\n  color: #a3a3a3;\n}\n\n.detailValue {\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n:global(.theme--light) .detailValue {\n  color: #212121;\n}\n:global(.theme--dark) .detailValue {\n  color: #f0f0f0;\n}\n\n.right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: space-between;\n}\n\n.searchWrapper {\n  flex: 1;\n  max-width: 320px;\n}\n\n.searchInputContainer {\n  min-height: 38px;\n}\n\n.filterWrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filterLabel {\n  font-size: 1.3rem;\n  white-space: nowrap;\n}\n:global(.theme--light) .filterLabel {\n  color: #888888;\n}\n:global(.theme--dark) .filterLabel {\n  color: #a3a3a3;\n}\n\n.filterSelect {\n  display: inline-block;\n  min-width: 120px;\n}\n\n.tableWrap {\n  flex: 1;\n  min-height: 320px;\n  max-height: 480px;\n  overflow: auto;\n  border-radius: 6px;\n}\n:global(.theme--light) .tableWrap {\n  border: 1px solid #dddddd;\n}\n:global(.theme--dark) .tableWrap {\n  border: 1px solid #2f2f2f;\n}\n\n.stateContainer {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 320px;\n  font-size: 1.4rem;\n}\n:global(.theme--light) .stateContainer {\n  color: #888888;\n}\n:global(.theme--dark) .stateContainer {\n  color: #a3a3a3;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 2.4rem;\n  margin-top: 16px;\n}\n:global(.theme--light) .footer {\n  border-top: 1px solid #dddddd;\n}\n:global(.theme--dark) .footer {\n  border-top: 1px solid #2f2f2f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ViewHistory-module_root___qPmtY`,
	"left": `ViewHistory-module_left___hAyAF`,
	"detailBlock": `ViewHistory-module_detailBlock___wMCud`,
	"detailLabel": `ViewHistory-module_detailLabel___N8d5Y`,
	"detailValue": `ViewHistory-module_detailValue____Dgs9`,
	"right": `ViewHistory-module_right___iBlPh`,
	"toolbar": `ViewHistory-module_toolbar___wsRNi`,
	"searchWrapper": `ViewHistory-module_searchWrapper___PWcE5`,
	"searchInputContainer": `ViewHistory-module_searchInputContainer___GEIwv`,
	"filterWrapper": `ViewHistory-module_filterWrapper___iFEhz`,
	"filterLabel": `ViewHistory-module_filterLabel____ZxwT`,
	"filterSelect": `ViewHistory-module_filterSelect___rJww_`,
	"tableWrap": `ViewHistory-module_tableWrap___ePwVB`,
	"stateContainer": `ViewHistory-module_stateContainer___TClhz`,
	"footer": `ViewHistory-module_footer___LBV67`
};
export default ___CSS_LOADER_EXPORT___;
